import { Card, Tabs } from "antd"
import React, { useState } from "react"
import IceGate from "./ice-gate"
import BRC from "./brc"
import ScriptGeneration from "./script-generaton"
import Sale from "./sale"
import ReceiveSale from "./receive"

export interface RodtepProps {
    tab:string
  }
  
  export function Rodtep(props: RodtepProps) {
    const [activeTab, setActiveTab] = useState("1")
    return (
        <Card>
            <Tabs type={'card'} tabPosition={'top'} onChange={setActiveTab}>
                <Tabs.TabPane tab="Ice Gate"  key="1">
                <IceGate tab={props.tab} activeTab={activeTab} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="BRC"  key="2">
                    <BRC tab={props.tab} activeTab={activeTab}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Script Generation"  key="3">
                    <ScriptGeneration tab={props.tab} activeTab={activeTab}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Sale"  key="4">
                    <Sale tab={props.tab} activeTab={activeTab}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab = "Receive" key ="5">
                    <ReceiveSale tab={props.tab} activeTab={activeTab}/>
                </Tabs.TabPane>
            </Tabs>
      
        </Card>
    )
  }
  export default Rodtep
   
